module.exports = __webpack_public_path__ + "img/coin-keeper.a1739f6e.svg";